import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-administrators',
  templateUrl: './administrators.component.html',
  styleUrls: ['./administrators.component.css']
})
export class AdministratorsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
